import React, {Component} from 'react';
import {ReactiveBase} from '@appbaseio/reactivesearch';

import theme from './styles/theme';

import LeftArea from './components/LeftArea';
import Results from './components/results/Results';
import SelectedFilterArea from './components/SelectedFilters'
import TextSearch from './components/TextSearch';
import {DetailsOverlay} from './components/results/details/Details';
import Error, {ErrorBoundary} from './components/Error';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "react-table/react-table.css";

import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faBan,
    faCaretRight,
    faCheckCircle,
    faCloudSunRain,
    faDraftingCompass,
    faExclamationCircle,
    faExclamationTriangle,
    faGlobe,
    faKey,
    faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'

import {faClipboard} from '@fortawesome/free-regular-svg-icons'

import Container, {appContainer, resultsContainer} from './styles/Container';
import Flex, {FlexChild} from './styles/Flex';

library.add(
    faBan,
    faCaretRight,
    faCheckCircle,
    faClipboard,
    faCloudSunRain,
    faDraftingCompass,
    faExclamationCircle,
    faExclamationTriangle,
    faGlobe,
    faKey,
    faTimesCircle,
);

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
            modal: {
                show: false,
                type: null,
                data: null,
                metadata: null
            },
            esUrl: "https://search-modeldata-inventory-test-7oyhfkml64yyi4ldjdcece63qi.eu-west-1.es.amazonaws.com",
            modelIndexBase: "inventory-models",
            parameterIndexBase: "inventory-parameters",
            gridIndexBase: "inventory-grids",
            env: process.env.REACT_APP_ES_ENV || "dev",
        };
    }

    showModal = (type, data, metadata) => {
	    this.setState({
            modal: {
                show: true,
                type: type,
                data: data,
                metadata: metadata
            }
        });
    };

	closeModal = () => {
	    this.setState({
            modal: {
                show: false,
                type: null,
                data: null,
                metadata: null
            }
        });
    };

    getModelIndexName = () => this.state.modelIndexBase + '-' + this.state.env;

    getParameterIndexName = () => this.state.parameterIndexBase + '-' + this.state.env;

    getGridIndexName = () => this.state.gridIndexBase + '-' + this.state.env;

    showError = (errorCode, errorMessage, errorDetails) => {
        toast.error(
            <Error
                errorCode={errorCode}
                errorMessage={errorMessage}
                errorDetails={errorDetails}
            />
        );
    };

    handleError = (errorCode, errorMessage, errorDetails) => {
        console.log("handleError", errorCode, errorMessage, errorDetails);
        this.showError(errorCode, errorMessage, errorDetails)
    };

    render() {
        console.log('Environment:', this.state.env);
        console.log('Using index:', this.getParameterIndexName());

        return (
            <Container>
                <ErrorBoundary handleError={this.handleError}>
                    <ToastContainer
                        autoClose={10000}
                        newestOnTop
                    />
                </ErrorBoundary>
                <ErrorBoundary handleError={this.handleError}>
                    <DetailsOverlay
                        modalState={this.state.modal}
                        close={this.closeModal}
                    />
                </ErrorBoundary>
                <ReactiveBase
                    app={this.getParameterIndexName()}
                    url={this.state.esUrl}
                    theme={theme}
                >
                    <Flex direction="row-reverse" className={appContainer}>
                        <ErrorBoundary handleError={this.handleError}>
                            <LeftArea/>
                        </ErrorBoundary>
                        <FlexChild className={resultsContainer}>
                            <ErrorBoundary handleError={this.handleError}>
                                <TextSearch/>
                            </ErrorBoundary>
                            <ErrorBoundary handleError={this.handleError}>
                                <SelectedFilterArea/>
                            </ErrorBoundary>
                            <ErrorBoundary handleError={this.handleError}>
                                <Results
                                    handleError={this.handleError}
                                    showModal={this.showModal}
                                    esUrl={this.state.esUrl}
                                    modelIndexName={this.getModelIndexName()}
                                    parameterIndexName={this.getParameterIndexName()}
                                    gridIndexName={this.getGridIndexName()}
                                />
                            </ErrorBoundary>
                        </FlexChild>
                    </Flex>
                </ReactiveBase>
            </Container>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js